import { clsx, ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Returns a combination of multiple classes into a single string.
 * @param inputs Classes.
 * @returns Combined classes.
 */
export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}
